import { useColorScheme } from "@mui/material/styles";

export type ThemeModeValue = "light" | "dark" | "system";

export interface ThemeModeOption {
	value: ThemeModeValue;
	label: string;
}

export const THEME_MODE_OPTIONS: ThemeModeOption[] = [
	{ value: "light", label: "Light" },
	{ value: "dark", label: "Dark" },
	{ value: "system", label: "System" },
];

export interface ThemeModeToggleViewModel {
	/** The mode to render as active. `mode` is `undefined` on first render (MUI design), so
	 * we fall back to "system" for display without mutating MUI's real (undefined) state. */
	activeMode: ThemeModeValue;
	setMode: (mode: ThemeModeValue) => void;
	options: ThemeModeOption[];
}

/**
 * Wraps MUI's built-in `useColorScheme()`. Persistence (localStorage `mui-mode`) and
 * OS-preference following for "system" are handled entirely by MUI — this VM adds only the
 * first-render `undefined` guard and the option list. No local state, no effect, no store.
 */
export function useThemeModeToggleViewModel(): ThemeModeToggleViewModel {
	const { mode, setMode } = useColorScheme();
	return {
		activeMode: mode ?? "system",
		setMode: (value: ThemeModeValue) => setMode(value),
		options: THEME_MODE_OPTIONS,
	};
}
